Auth = require 'db/auth'
Browser = require 'lib/browser'
PopOver = require 'views/lib/pop-over'
React = require 'react'
t = require('views/internal/recup-with-helpers')('list_add')
Util = require 'lib/util'
track = require 'debug/track'
$ = require 'jquery'

DISMISSAL_KEY = 'GuidedStepsInviteMore'
MAX_LIST_NAME = 512
RENDER_TIMEOUT = 100

module.exports = class extends React.Component
  displayName: 'GuidedStepListComposerComponent'

  constructor: (props) ->
    super(props)

    @state = {
      listComposerOpen: @props.model.listList.length == 0
      inviteMoreDismissed: true
      inviteMoreDisplayed: false
      listName: ''
      listPlaceholderShown: false
    }

  dismissInviteMore: =>
    @setState({ inviteMoreDismissed: true })
    Auth.me().dismiss(DISMISSAL_KEY)
    track("Board View", "Guided Step List Composer", "Dismissed Invite More")

  isInviteMoreDismissed: =>
    Auth.me().isDismissed(DISMISSAL_KEY)

  toggleListComposer: (isOpen) =>
    (e) =>
      Util.stop(e)
      @setState { listComposerOpen: isOpen }
      PopOver.hide()

  updateListTitle: (e) =>
    Util.stop(e)
    @setState { listName: e.target.value, listPlaceholderShown: true }

  focusListInput: =>
    setTimeout ->
      $('.list-name-input').focus().select()
    , RENDER_TIMEOUT

  closeListComposer: (e) =>
    if e.target.id == 'board'
      @setState { listComposerOpen: false || @state.listName }

    @focusListInput()

  suggestGhostCardCreation: (listsLength) =>
    if listsLength in [1, 2]
      setTimeout =>
        $('.js-open-card-composer').click()
      , RENDER_TIMEOUT

  addList: (e) =>
    Util.stop(e)

    { model } = @props
    $input = $('.list-name-input')
    lists = model.listList
    listsLength = lists.length + 1

    listName = @state.listName.trim()

    if listName == ''
      $input.focus().select()
      return

    @setState {
      listComposerOpen: listsLength > 2
      listName: ''
      listPlaceholderShown: false
    }, =>
      model.listList.create(
        {
          name: listName,
          pos: model.calcPos(listsLength),
          closed: false
        },
        {
          success: (model) =>
            track("Board View", "Add List - via Inline List Composer")
            track("Board View", "Guided Step List Composer", "Add List", listsLength)
        }
      )

      $input.val('')

      @suggestGhostCardCreation(listsLength)
    return

  displayInviteMoreMembers: (model) =>
    if (@state.inviteMoreDisplayed == true && model.viewState.get('showSidebar') == false) || model.memberList.length > 1
      @setState({ inviteMoreDismissed: true })
    else if !@isInviteMoreDismissed() && @state.inviteMoreDisplayed == false &&
      model.listList.length >= 2 && model.listList.models[1].cardList.length == 2
        @setState({ inviteMoreDismissed: false, inviteMoreDisplayed: true })

  componentDidMount: ->
    @displayInviteMoreMembers(@props.model)
    @focusListInput()
    setTimeout =>
      $('#board').click(@closeListComposer)
    , RENDER_TIMEOUT

  componentWillReceiveProps: (nextProps) ->
    @displayInviteMoreMembers(nextProps.model)

  render: t.renderable ->
    { model } = @props

    firstListPopulated = model.listList.length == 1 && model.listList.models[0].cardList.length == 2
    isIdle = if @state.listComposerOpen == true then '' else 'is-idle'
    isHighlighted = if firstListPopulated && !@state.listComposerOpen then 'mod-green' else ''
    hasList = if model.listList.length > 0 then 'mod-added' else ''
    t.div =>
      t.div '.js-add-list.list-wrapper.mod-add', { class: [hasList, isIdle, isHighlighted].join(' ') }, =>
        t.form { onSubmit: @addList }, =>
          t.span '.placeholder.js-open-add-list', { onClick: @toggleListComposer(true) }, =>
            if firstListPopulated then t.format 'fourth-guided-step' else t.format 'add-a-list-ellipsis'

          if @state.listComposerOpen == true
            placeholder = if model.listList.length >= 1 then t.l('guided-step-add-list') else t.l('first-guided-step')
            value =
              if !@state.listPlaceholderShown && Browser.browserVersionStr in ['explorer-10', 'explorer-11']
                placeholder
              else
                @state.listName

            textSize =
              if placeholder.length > 32
                '.small'
              else
                ''

            t.input ".list-name-input#{textSize}",
              type: 'text'
              name: 'name'
              placeholder: placeholder
              autoComplete: 'off'
              dir: 'auto'
              maxLength: MAX_LIST_NAME
              onChange: @updateListTitle
              value: value

            t.div '.list-add-controls.u-clearfix', =>
              t.input '.primary.mod-list-add-button.js-save-edit', { type: 'submit', value: t.l('save') }
              t.a '.icon-lg.icon-close.dark-hover.js-cancel-edit', { href: '#', onClick: @toggleListComposer(false) }

      if @state.inviteMoreDismissed == false
        track("Board View", "Guided Step List Composer", "Displayed Invite More")
        model.viewState.setShowSidebar(true)
        t.div '.invite-more', =>
          t.div '.arrow'
          t.div '.add-more-brain-power', ->
            t.format 'add-more-brain-power'
          t.div '.add-more-brain-power-body', ->
            t.format 'add-more-brain-power-body'
          t.button '.primary.got-it', { onClick: @dismissInviteMore }, ->
            t.format 'got-it'



// WEBPACK FOOTER //
// ./app/scripts/views/list/guided-step-list-composer-component.coffee